import { AImageProps } from '../../atoms/AImage/AImage.types';
import { AScrimGradientProps } from '../../atoms/AScrimGradient/AScrimGradient.types';
import { MBrandElementProps } from '../../molecules/MBrandElement/MBrandElement.types';
import { MTextBlockSimpleProps } from '../../molecules/MTextBlockSimple/MTextBlockSimple.types';
import { MButtonProps } from '../../molecules/MButton/MButton.types';
import { MPhotoCaptionProps } from '../../molecules/MPhotoCaption/MPhotoCaption.types';

export enum OHeroImageContentAlignment {
  Left = 'Left',
  Center = 'Center',
  Bottom = 'Bottom',
}

export enum OHeroImageImageScale {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
}

export interface OHeroImageProps extends React.HTMLAttributes<HTMLDivElement> {
  contentAlignment?: OHeroImageContentAlignment;
  imageScale?: OHeroImageImageScale;
  photoCaption?: boolean;
  secondaryButton?: boolean;
  logo?: boolean;
  aImage?: AImageProps;
  aScrimGradient?: AScrimGradientProps;
  mBrandElement?: MBrandElementProps;
  mTextBlockSimple?: MTextBlockSimpleProps;
  mButton?: MButtonProps;
  mButton2?: MButtonProps;
  mPhotoCaption?: MPhotoCaptionProps;
  className?: string;
}
